import { Outlet, useNavigate, useLocation } from "react-router-dom";
import { Users, Hotel, GitCompareArrows, AlignVerticalJustifyEnd, Network } from "lucide-react";
import Sidebar from "../components/sidebar.js";
import { API_BASE } from "../utils/draftutils"; // <<< URL base backend

export default function MenuConfig({ role, username }) {
  const navigate = useNavigate();
  const location = useLocation();

  const menuItems = [
    { name: "Crea comprensorio", path: "crea-comprensorio", icon: <GitCompareArrows size={20} /> },
    { name: "Visualizza comprensori", path: "visualizza-comprensori", icon: <Hotel size={20} /> },
    { name: "Crea servizi", path: "crea-gerarchia", icon: <Network size={20} /> },
    { name: "Visualizza servizi", path: "visualizza-gerarchie", icon: <AlignVerticalJustifyEnd size={20} /> },
    { name: "Visualizza proposte chiuse", path: "visualizza-insiemichiusi", icon: <Users size={20} /> },
  ];

  const handleLogout = async () => {
    try {
      await fetch(`${API_BASE}/api/auth/logout`, {
        method: "POST",
        credentials: "include",
      });
      navigate("/");
    } catch (err) {
      console.error("Errore durante il logout", err);
    }
  };

  return (
    <div className="app">
      <Sidebar 
        role={role}
        menuItems={menuItems}
        handleLogout={handleLogout}
        username={username}
      />
      {/* Qui cambiano le pagine */}
      <main className="content bg-body-tertiary" style={{ height: "100vh" }}>
        {location.pathname === "/menuconfig" ? (
          <div className="d-flex align-items-center justify-content-center h-100">
            <p className="text-muted" style={{ fontSize: "1.4rem" }}>
              Seleziona una funzione dal menu per continuare
            </p>
          </div>
        ) : (
          <Outlet />
        )}
      </main>
    </div>
  );
}
